import { z } from 'zod';
import { DateSchema, ObjectIdHexStringSchema, ObjectIdSchema } from './base';
import { DeviceClasses } from './trackers';

export const EventStarterKeySchema = z.object({
  id: ObjectIdSchema,
  key: z.string().min(6).max(6), // 6 Digits of Letters and numbers
  used: z.boolean(),
  eventId: ObjectIdSchema, // the related event ID
  createdAt: DateSchema,
  updatedAt: DateSchema,
});

export type EventStarterKey = z.infer<typeof EventStarterKeySchema>;

export const EventStarterKeysSchema = z.array(EventStarterKeySchema);

export type EventStarterKeys = z.infer<typeof EventStarterKeysSchema>;

// GET /api/starters/actions/check_key
export const CheckEventStarterKeyQuerySchema = z.object({
  key: z.string().min(1).optional(),
  used_ok: z.enum(['true', 'false']).optional(),
});

export type CheckEventStarterKeyQuery = z.infer<typeof CheckEventStarterKeyQuerySchema>;

export const CheckEventStarterKeyResponseSchema = z.object({
  startNumber: z.string().nullable(),
  name: z.string().nullable(),
  eventId: ObjectIdHexStringSchema,
  eventName: z.string(),
  starterId: ObjectIdHexStringSchema.nullable(),
  keyUsed: z.boolean(),
});

export type CheckEventStarterKeyResponse = z.infer<typeof CheckEventStarterKeyResponseSchema>;

// POST /api/starters/actions/link_with_key
export const LinkEventStarterKeyQuerySchema = z.object({
  key: z.string().optional(),
  appId: z.string().optional(),
});

export type LinkEventStarterKeyQuery = z.infer<typeof LinkEventStarterKeyQuerySchema>;

export const LinkEventStarterKeyBodySchema = z.object({
  name: z.string().optional(),
  startNumber: z.string().optional(),
  deviceType: z.string().optional(),
  deviceClass: z.enum(DeviceClasses).optional(),
  integrations: z
    .object({
      messagingToken: z.string().optional(),
    })
    .optional(),
});

export type LinkEventStarterKeyBody = z.infer<typeof LinkEventStarterKeyBodySchema>;

// The controller actually returns a permission-filtered Starter, but no
// caller of the `linkEventStarterKey` client method needs more than this —
// keep the contract to what's used instead of re-modelling all of Starter.
// `name`, `startNumber`, `eventId`, and `integrations.messagingToken` are
// consumed by the native app, not just the web clients below.
export const LinkEventStarterKeyResponseSchema = z.object({
  id: ObjectIdHexStringSchema,
  eventId: ObjectIdHexStringSchema,
  key: z.string().optional(),
  name: z.string(),
  startNumber: z.string(),
  startTime: z.string().optional(),
  integrations: z
    .object({
      messagingToken: z.string().nullish(),
    })
    .optional(),
});

export type LinkEventStarterKeyResponse = z.infer<typeof LinkEventStarterKeyResponseSchema>;
